import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './FilterBarNews.scss';
import { setActiveTabNews } from '../../Reducers/actions/newsActions';
import Icon from '../Icon/Icon';

const FilterBarNews = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector(state => state.news.activeTab);

  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'subscriptions', label: 'SUBS' },
    { id: 'saved', label: <Icon alias="star" width={20} color='#222' />, label_active: <Icon alias="star" width={20} color='#FFF' /> },
  ];

  const handleTabClick = (tab) => {
    dispatch(setActiveTabNews(tab));
  };

  return (
    <div className="filter-news-bar">
      {tabs.map((category) => (
        <button
          key={category.id}
          className={`filter-news-item ${activeTab === category.id ? 'active' : ''}`}
          onClick={() => handleTabClick(category.id)}
        >
          <span>{activeTab === category.id && category.label_active ? category.label_active : category.label}</span>
        </button>
      ))}
    </div>
  );
};

export default FilterBarNews;